import LetterbooksViewType from "types/LetterbooksViewType";
import { LetterbookSettingType } from "../types";

interface UrlOverrides extends Record<string, string> {
  order?: string;
  direction?: "asc" | "desc";
  view?: LetterbooksViewType;
  columns?: string;
  start?: string;
}
interface SettingOverrides {
  addColumn?: string;
  removeColumn?: string;
}

function columnOverrides(
  settings: LetterbookSettingType,
  settingOverrides?: SettingOverrides
) {
  if (settingOverrides?.addColumn) {
    const columns = [
      ...settings.tableColumns.map((column) => column.key),
      settingOverrides.addColumn,
    ];
    return { columns: columns.join(",") };
  }

  // Generate URL with a change from
  //   ?columns=ActiveColumns,Inactive
  // To
  //   ?columns=ActiveColumns
  if (settingOverrides?.removeColumn) {
    const columns = settings.tableColumns
      .map((column) => column.key)
      .filter((key) => key !== settingOverrides.removeColumn);
    return { columns: columns.join(",") };
  }

  return {};
}
export default function generateUrl({
  settings,
  overrides = {},
  settingOverrides = {},
}: {
  settings: LetterbookSettingType;
  overrides?: UrlOverrides;
  settingOverrides?: SettingOverrides;
}) {
  const view = overrides.view || settings.view;
  const urlOverrides = { ...overrides };
  delete urlOverrides.view;
  const newParams = {
    ...settings.searchParams,
    ...urlOverrides,
    ...{ view },
    ...columnOverrides(settings, settingOverrides),
  };
  const params = new URLSearchParams(newParams as unknown as Record<string, string>).toString();

  return `${settings.url}${params ? `?${params}` : ""}`;
}
